// extracted by mini-css-extract-plugin
export default {"linkRow":"LinkRow_linkRow__B4AmQ","chevron":"LinkRow_chevron__RVIxk"};